<template>
  <div class="ui segments">
    <div class="ui segment" style="background-color: #f6feff">
      <el-row>
        <el-col :span="4"><div class="summary-title">Email:</div></el-col>
        <el-col :span="17"
          ><div>{{ email }}</div></el-col
        >
        <el-col :span="3">
          <el-button type="text" style="padding:0" @click="onClickChangeInfo"
            >Change</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="ui segment" style="background-color: #f6feff">
      <el-row>
        <el-col :span="4"><div class="summary-title">Billing:</div></el-col>
        <el-col :span="17"
          ><div class="">{{ address }}</div></el-col
        >
        <el-col :span="3">
          <el-button type="text" style="padding:0" @click="onClickChangeInfo"
            >Change</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div
      class="ui segment"
      style="background-color: #f6feff"
      v-if="shippingAddress"
    >
      <el-row>
        <el-col :span="4"><div class="summary-title">Shipping:</div></el-col>
        <el-col :span="17"
          ><div class="">{{ shippingAddress }}</div></el-col
        >
        <el-col :span="3">
          <el-button type="text" style="padding:0" @click="onClickChangeInfo"
            >Change</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="ui segment" style="background-color: #f6feff">
      <el-row>
        <el-col :span="4"><div class="summary-title">My Kids:</div></el-col>
        <el-col :span="17"
          ><div class="">{{ strKidsInOrder }}</div></el-col
        >
        <el-col :span="3">
          <el-button type="text" style="padding:0" @click="onClickChangeInfo"
            >Change</el-button
          >
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactAddressSummaryWidget",
  props: {
    email: {
      type: String,
      required: true
    },
    address: {
      type: String,
      required: true
    },
    shippingAddress: {
      validator: prop => typeof prop === "string" || prop === null,
      required: false
    },
    countKids: {
      type: Number,
      required: true
    }
  },
  methods: {
    onClickChangeInfo() {
      this.$emit("evt-request-to-change-address-info");
    }
  },
  computed: {
    strKidsInOrder() {
      if (this.countKids === 0) {
        return "No kids are added to the order";
      } else {
        const strKids = this.$tc("kid", this.countKids);
        return `${this.countKids} ${strKids} added to the order`;
      }
    }
  }
};
</script>

<style scoped>
.summary-title {
  color: #000000;
  font-weight: 500;
}
</style>
<style lang="stylus">
@import '../../../../styles/css/segments.css'
</style>
